export default "__VITE_ASSET__3zx6pGQe__"